import React from 'react';
import styled, { keyframes } from 'styled-components';
import { SpinnerProps } from './Spinner.types';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const rotateReverse = keyframes`
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

const StyledSpinner = styled.div<SpinnerProps>`
  animation: ${(props) => (props.theme.rtl ? rotateReverse : rotate)} 1s linear infinite;
  border-radius: 50%;
  border-left: 2px solid transparent !important;
  cursor: wait;
  border-top: 2px solid ${(props) => (props.color ? props.color : props.theme.colors.palette.black)};
  border-right: 2px solid
    ${(props) => (props.color ? props.color : props.theme.colors.palette.black)};
  border-bottom: 2px solid
    ${(props) => (props.color ? props.color : props.theme.colors.palette.black)};
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  margin: ${(props) => (props.inline ? '0 auto' : 'unset')};
  position: ${(props) => (!props.inline ? 'absolute' : 'relative')};
  top: ${(props) => (!props.inline ? 'calc(50% - 30px)' : 'unset')};
  left: ${(props) => (!props.inline ? 'calc(50% - 30px)' : 'unset')};
  transform: ${(props) => (!props.inline ? 'translate(-50%, -50%)' : 'unset')};
`;

const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps): React.ReactElement => {
  const { color, size = 60, style = {}, inline = false } = props;

  return (
    <StyledSpinner
      className='spinner'
      {...props}
      color={color}
      size={size}
      style={style}
      inline={inline}
    />
  );
};

export default Spinner;
